module.exports = __webpack_public_path__ + "static/media/local_post_office.6b5ad484.svg";